/*
 * Public API Surface of ngrx-labs
 */

export * from './lib/ngrx-labs.module';
export * from './lib/decorators';
